import Vue from "vue";
import { VNodeDirective } from "vue";
import { removeTags } from "../utils";

Vue.directive("safe-html",  {
	bind(el:HTMLElement, binding:VNodeDirective) {
		el.innerHTML = removeTags(binding.value);
	},
	update(el:HTMLElement, binding:VNodeDirective){
		el.innerHTML = removeTags(binding.value);
	}
});